import React from "react";
import styles from "./styles/EstatePlanning.module.css";
import { useNavigate } from "react-router-dom";
import { Sidebar } from "../Sidebar/Sidebar";
import data from "../../../data/multilanguage.json";
import { useState } from "react";
import { useContext } from "react";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { useEffect } from "react";
export function EstatePlanning() {
  const navigate = useNavigate();
  window.scrollTo(0, 0);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  return (
    <>
      <h1 className={styles.page_title}>{dublicatedcontent.dublicatedText6}</h1>
      <div className={styles.page_with_sidebar}>
        <Sidebar></Sidebar>
        <div className={styles.main}>
          <div className={styles.page_container}>
            <div className={styles.title}>
              {dublicatedcontent.dublicatedText7}
            </div>
            <div className={styles.subtitle}>
              {dublicatedcontent.dublicatedText8}
            </div>
            <p>{dublicatedcontent.dublicatedText9}</p>
            <p>{dublicatedcontent.dublicatedTex10}</p>
            <ul>
              <li>
                <b>{dublicatedcontent.dublicatedTex11}</b>
                {dublicatedcontent.dublicatedText12}
              </li>
              <li>
                {dublicatedcontent.dublicatedText13}
                <ul>
                  <li>
                    <b>{dublicatedcontent.dublicatedText14}</b>
                    {dublicatedcontent.dublicatedText15}
                    <ul>
                      <li>
                        <b>{dublicatedcontent.dublicatedText16}</b>
                        {dublicatedcontent.dublicatedText17}
                      </li>
                    </ul>
                  </li>
                  <li>
                    <b>{dublicatedcontent.dublicatedText18}</b>{" "}
                    {dublicatedcontent.dublicatedText19}
                    <ul>
                      <li>
                        <b>{dublicatedcontent.dublicatedText20}</b>
                        {dublicatedcontent.dublicatedText21}
                      </li>
                    </ul>
                  </li>
                  <li>
                    <b>{dublicatedcontent.dublicatedText22}</b>{" "}
                    {dublicatedcontent.dublicatedText23}
                  </li>
                </ul>
                <li>
                  <b>{dublicatedcontent.dublicatedText24}</b>
                  {dublicatedcontent.dublicatedText25}
                </li>
                <li>
                  <b>{dublicatedcontent.dublicatedText26}</b>
                  {dublicatedcontent.dublicatedText27}
                </li>
                <li>
                  <b>{dublicatedcontent.dublicatedText28}</b>
                  {dublicatedcontent.dublicatedText29}
                  <br />
                  <b>{dublicatedcontent.dublicatedText30}</b>
                  <ul>
                    <li>{dublicatedcontent.dublicatedText31}</li>
                    <li>{dublicatedcontent.dublicatedText32}</li>
                  </ul>
                </li>
              </li>
            </ul>

            <p>{dublicatedcontent.dublicatedText33}</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default EstatePlanning;
